<template>
  <b-card no-body class="card-developer-meetup">
    <div class="bg-light-primary rounded-top text-center" v-if="mediaData">
      <b-img
        :src="require('@/assets/images/illustration/email.svg')"
        alt="Meeting Pic"
        height="170"
      />
    </div>
    <b-card-body>
      <!-- metting header -->
      <div class="meetup-header d-flex align-items-center">
        <div class="meetup-day">
          <h6 class="mb-0">
            {{ moment(mediaData.start_in).format("dddd") }}
          </h6>
          <h3 class="mb-0">   {{ moment(mediaData.start_in).format("DD") }}</h3>
        </div>
        <div class="my-auto">
          <b-card-title class="mb-25" v-html="mediaData.title"> </b-card-title>
          <b-card-text class="mb-0" v-html="mediaData.description">
          </b-card-text>
        </div>
      </div>
      <!--/ metting header -->

      <!-- media -->

      <hr />
      <b-button block variant="relief-secondary" v-if="checkTime(mediaData)">
        لم تبدأ بعد
      </b-button>

      <b-button
        v-else-if="mediaData.is_end == 0"
        block
        variant="relief-info"
        @click="openLive(mediaData)"
      >
        دخول
      </b-button>
    </b-card-body>
  </b-card>
</template>

<script>
import SettingController from "@/Controllers/SettingController";
import Auth from "@/Apis/Auth";
import OnlineSessionController from "@/Controllers/OnlineSessionController";
export default {
  props: {
    mediaData: Object,
  },
  components: {},
  directives: {
    // 'b-tooltip': VBTooltip,
  },
  data() {
    return {
      time:""
    };
  },
  async created() {
    this.time = await new SettingController().time();
  },
  methods: {
    checkTime(item) {
      if (!item.start_in) return false;

      const check = new Date(this.time.SERVERTIME);
      const stDate = Auth.GetDateTimeZone(item.start_in, true);
      if (check.getTime() >= stDate.getTime()) return false;
      return true;
    },
    openLive(data) {
      new OnlineSessionController().joinLecture(data.id);
    },
    returnData(){
       return {valid:this.mediaData.is_end == 1}
    }
  },
};
</script>